// @flow
import React, { Fragment, PureComponent } from 'react';
import { Link, withRouter } from 'react-router-dom';

// import ParionsSportCote from 'containers/parionsSport/ParionsSportCoteContainer';
import { getDateFromString, formatHours, formatFullDateString } from 'utils/dateUtils';
import { dynamicClassName } from 'utils/dynamicClassName';
import { handleTagEvent } from 'utils/tagManagerUtils';
import { getPathname } from 'utils/urlUtils';
import type { EventMatchType } from 'types/Event';
import type { RouterProps } from 'types/Router';
import type { FullUserType } from 'types/User';

import defaultImgTeam from 'assets/img/logo/placeholder-club.png';

export type StateProps = {
  userPref: FullUserType,
  alertesBilletterie: Array<number>,
  identifie: boolean
};

export type DispatchProps = {
  postUserPref: (action: string, value: any, token: string) => void,
  displayModal: (modalObject: string, content?: Object) => void
};

type Props = StateProps &
  DispatchProps &
  RouterProps & {
    event: EventMatchType,
    from?: string,
    hasMargin?: boolean,
    eventList?: boolean
  };

type State = {
  isTabletOrMobile: boolean,
  isMobile: boolean
};

class EventListElementMatch extends PureComponent<Props, State> {
  state: State = {
    isTabletOrMobile: window.innerWidth <= 1024,
    isMobile: window.innerWidth <= 768
  };

  renderBodyAdversaire() {
    const {
      event: {
        startDate: startDateEvent,
        endDate: endDateEvent,
        reception,
        city,
        zip,
        adress: adressEvent,
        adversaire,
        france,
        title,
        link: linkEvent
      },
      from
    } = this.props;

    const startDate = getDateFromString(startDateEvent);
    const endDate = getDateFromString(endDateEvent);
    const adress = `${adressEvent} ${zip} ${city}`;
    const link = getPathname(linkEvent);
    const isFromDashboard = from && from === 'dashboard';

    return (
      <Fragment>
        {!reception && (
          <Link
            to={link}
            target={isFromDashboard ? '_blank' : '_self'}
            title={`Voir le détail de l'événement : ${title}`}
          >
            <p className="ft-h3 ft-400">
              <img
                src={adversaire.logo ? adversaire.logo : defaultImgTeam}
                alt={`Logo ${adversaire.name}`}
                width="40"
                height="40"
              />
              {adversaire.name}
            </p>
            <p className="ft-h3 ft-400">
              <img src={france.logo ? france.logo : defaultImgTeam} alt="Logo XV de France" width="40" height="40" />
              France
            </p>
          </Link>
        )}
        {reception && (
          <Link
            to={link}
            target={isFromDashboard ? '_blank' : '_self'}
            title={`Voir le détail de l'événement : ${title}`}
          >
            <p className="ft-h3 ft-400">
              <img src={france.logo ? france.logo : defaultImgTeam} alt="Logo XV de France" width="40" height="40" />
              France
            </p>
            <p className="ft-h3 ft-400">
              <img
                src={adversaire.logo ? adversaire.logo : defaultImgTeam}
                alt={`Logo ${adversaire.name}`}
                width="40"
                height="40"
              />
              {adversaire.name}
            </p>
          </Link>
        )}
        <ul className="list-type ft-h6 ft-up mt-4 mb-0 mb-md-1 mb-lg-3">
          {adressEvent && (
            <li>
              <a
                href={`https://www.google.com/maps/search/${adress}`}
                target="__blank"
                className="event__info"
                style={{ display: 'inline-block' }}
              >
                <i className="icon icon-place is-inline" />
                {adress}
              </a>
            </li>
          )}
          <li>
            <i className="icon icon-clock is-inline" />
            {formatHours(startDate)}
            {startDate.getTime() !== endDate.getTime() && ` - ${formatHours(endDate)}`}
          </li>
        </ul>
      </Fragment>
    );
  }

  updateDimensions = () => {
    const { isTabletOrMobile, isMobile } = this.state;
    if (window.innerWidth <= 1024 && !isTabletOrMobile) {
      this.setState({ isTabletOrMobile: true });
    }
    if (window.innerWidth > 1024 && isTabletOrMobile) {
      this.setState({ isTabletOrMobile: false });
    }
    if (window.innerWidth <= 768 && !isMobile) {
      this.setState({ isMobile: true });
    }
    if (window.innerWidth > 768 && isMobile) {
      this.setState({ isMobile: false });
    }
  };

  componentDidMount() {
    const {
      alertesBilletterie,
      identifie,
      postUserPref,
      displayModal,
      event: { id }
    } = this.props;
    const localAlert = localStorage.getItem('alertLocal');

    window.addEventListener('resize', this.updateDimensions.bind(this));

    if (
      identifie &&
      id === parseInt(localAlert, 10) &&
      localAlert &&
      localAlert !== '' &&
      !alertesBilletterie.includes(parseInt(localAlert, 10))
    ) {
      postUserPref('billetterie-alerte-add', `${localAlert}`, this.props.userPref.token);
      localStorage.setItem('alertLocal', '');
      displayModal('MODAL_TICKETING_SUCCESS');
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  }

  renderBodyNoAdversaire() {
    const {
      event: { startDate: eventStartDate, endDate: eventEndDate, all_day, zip, city, adress: eventAdress },
      hasMargin,
      eventList
    } = this.props;

    const startDate = getDateFromString(eventStartDate);
    const endDate = getDateFromString(eventEndDate);
    const adress = `${eventAdress} ${zip} ${city}`;
    const classNamesCardContainer = dynamicClassName('card--nextGameFull__address ft-h6 ft-up');
    hasMargin && classNamesCardContainer.add('mt-3');

    return (
      <Fragment>
        {!all_day && eventList && (
          <span className="event__info">
            <i className="icon icon-clock is-inline" />
            {formatHours(startDate)}
            {startDate.getTime() !== endDate.getTime() && ` - ${formatHours(endDate)}`}
          </span>
        )}
        {eventAdress && (
          <p className={classNamesCardContainer.build()}>
            <a
              href={`https://www.google.com/maps/search/${adress}`}
              target="__blank"
              className="event__info"
              style={{ display: 'inline-block' }}
            >
              <i className="icon icon-place is-inline" />
              {adress}
            </a>
          </p>
        )}
      </Fragment>
    );
  }

  _renderActionButton = () => {
    const { isTabletOrMobile } = this.state;
    const {
      event: { id, adversaire, reception, startDate, billetterie, title },
      userPref,
      alertesBilletterie,
      //postUserPref,
      identifie,
      displayModal
    } = this.props;
    const dateToCompare = new Date();
    const startToCompare = new Date(startDate);
    const styleBilletterie = isTabletOrMobile ? { opacity: 1, display: 'block' } : {};
    const matchName = !adversaire ? '' : reception ? `France-${adversaire.name}` : `${adversaire.name}-France`;

    if (startToCompare > dateToCompare) {
      if (billetterie) {
        return (
          <a
            href={billetterie}
            className="btn btn--primary card--nextGameFull__button"
            style={styleBilletterie}
            onClick={handleTagEvent('billet_match', 'achat_billet', !adversaire ? 'not a match' : matchName, userPref)}
          >
            <i className="icon icon-store is-inline" />
            <span>Acheter vos billets</span>
          </a>
        );
      } else {
        if (adversaire) {
          if (identifie) {
            if (alertesBilletterie.includes(id)) {
              return (
                <a
                  tabIndex="0"
                  onClick={() => displayModal('MODAL_ADD_FAVORITE_PLAYER', { id, title })}
                  role="button"
                  className="btn mt-3 card--nextGameFull__button btn--white btn--full"
                >
                  <i className="icon icon-delete is-inline"></i>
                  <span>Supprimer mon alerte</span>
                </a>
              );
            } else {
              return null;
              /**
              return (
                <a
                  role="button"
                  tabIndex='0'
                  onClick={() => {
                    postUserPref('billetterie-alerte-add', `${id}`, this.props.userPref.token);
                    handleTagEvent(
                      'billet_match',
                      'alerte_billet',
                      title,
                      userPref
                    );
                    displayModal('MODAL_TICKETING_SUCCESS');
                  }}
                  className="btn mt-3 card--nextGameFull__button btn--white btn--full">
                  <i className="icon icon-store is-inline"></i>
                  <span>{`Être alerté de l'ouverture de la billetterie`}</span>
                </a>
              ); */
            }
          } else {
            return null;
            /*return (
              <a
                role="button"
                tabIndex='0'
                onClick={() => {
                  handleTagEvent(
                    'billet_match',
                    'alerte_billet',
                    title,
                    userPref
                  );
                  localStorage.setItem('alertLocal', `${id}`);
                  displayModal('MODAL_TICKETING');
                }}
                className="btn mt-3 card--nextGameFull__button btn--white btn--full">
                <i className="icon icon-store is-inline"></i>
                <span>{`Être alerté de l'ouverture de la billetterie`}</span>
              </a>
            );*/
          }
        }
      }
    }

    return null;
  };

  render() {
    const {
      eventList,
      event: { adversaire, team, startDate, title, tag, label }
    } = this.props;

    const classNamesCardContainer = dynamicClassName('box box--white card card--nextGameFull');
    this.props.hasMargin && classNamesCardContainer.add('mt-3');

    return (
      <div className={classNamesCardContainer.build()}>
        <div className="card__header">
          <span className="ft-h6 ft-up">{tag || label}</span>
          {!adversaire && !eventList && <span className="ft-h6 ft-up">{title} </span>}
          {!eventList && (
            <span className="ft-h6 ft-up">{formatFullDateString(startDate) + ' à ' + formatHours(startDate)}</span>
          )}
          {eventList && <span className="ft-h6 ft-up">{team}</span>}
        </div>
        <div className="card__body">
          <div className="team">{adversaire ? this.renderBodyAdversaire() : this.renderBodyNoAdversaire()}</div>
          {/* {this.props.match.params.slug === 'xv-de-france-masculin' && (
            <ParionsSportCote matchDate={startDate} classParent={'card--parions-sport-cote'} />
          )} */}
          <div className="mt-2">{this._renderActionButton()}</div>
        </div>
        <div className="card__footer"></div>
      </div>
    );
  }
}

export default withRouter(EventListElementMatch);
